import { useState } from 'react'
import PdfReader from '../PdfReader'

import WebsiteImg from '../../../assets/images/be-v1/website.png'
import BrochureImg from '../../../assets/images/be-v1/know-more.png'
import YoutubeImg from '../../../assets/images/be-v1/video.png'
import SocialImg from '../../../assets/images/be-v1/follow-us.png'
import ContactUsImg from '../../../assets/images/be-v1/contact-us.png'
import YoutubeVideos from './YoutubeVideos'
import { LinksProps, PdfReaderProps } from '../../../types/props'
import usePosthogEvent from '../../../hooks/use-posthog-event'
import { redirectToUrl } from '../../../utils/helperFunctions'
import defaultUrl from '../../../utils/defaultBrandEngagementUrls'
import config from '../../../config'

const Links = ({
  setYoutubeOpen,
  isYoutubeOpen,
  setBrochureOpen,
  isBrochureOpen,
  setModalOpen,
  brandEngagement,
  isLiveStream,
}: LinksProps) => {

  const [youtubeLinks, setYoutubeLinks] = useState<string | Array<string>>()
  const posthogEvent = usePosthogEvent()

  const linkList = brandEngagement?.page?.links || [
    {
      img: WebsiteImg,
      title: 'Website',
      url: brandEngagement?.content?.website || defaultUrl.WEBSITE,
    },
    {
      img: BrochureImg,
      title: 'Know more',
      url: '',
    },
    {
      img: YoutubeImg,
      title: 'Video',
      urls: brandEngagement?.content?.video || defaultUrl.YOUTUBE,
    },
    {
      img: SocialImg,
      title: 'Follow us',
    },
  ]

  const handleRedirect = (url: string, title = '') => {
    posthogEvent.sendBrandMarketingToolClickedEvent({ tool: 'Website' })
    if(title && title.toLowerCase() === 'website'){
      redirectToUrl(url, true)
    } else {
      redirectToUrl(url, false)
    }
  }

  const handleMedia = (title: string, urls?: string | Array<string>) => {
    const isYoutube = title === 'Video'
    const isBrochure = title === 'Know more'
    const isSocial = title === 'Follow us'

    if (isYoutube) {
      posthogEvent.sendBrandMarketingToolClickedEvent({ tool: 'Video' })
      setYoutubeOpen(true)
      setYoutubeLinks(urls)
      setModalOpen(false)
    }

    if (isBrochure) {
      posthogEvent.sendBrandMarketingToolClickedEvent({ tool: 'Brochure' })

      setYoutubeOpen(false)
      setModalOpen(false)
      setBrochureOpen(true)
    }

    if (isSocial) {
      setYoutubeOpen(false)
      setBrochureOpen(false)
      setModalOpen(true)
    }
  }

  const pdfReaderProps: PdfReaderProps = {
    brochureUrl: brandEngagement?.content?.brochure || config.BROCHURE_URL,
  }
  return (
    <>
      {isYoutubeOpen ? (
        <div className='youtube-embed text-center'>
          {typeof youtubeLinks === 'string' ? (
            <YoutubeVideos src={youtubeLinks[0]} />
          ) : (
            youtubeLinks?.map((youtubeLink, idx) => <YoutubeVideos key={idx} src={youtubeLink} />)
          )}
        </div>
      ) : isBrochureOpen ? (
        <PdfReader {...pdfReaderProps} />
      ) : (
        <>
          <div className='engagement__links v1-engagement__links'>
            {linkList.map((link, idx) => (
              <div
                key={idx}
                onClick={() => {
                  if ('url' in link && link.url) handleRedirect(link.url, link.title)
                  else if ('urls' in link && link.urls.length > 0)
                    handleMedia(link.title, link.urls)
                  else handleMedia(link.title)
                }}
              >
                <img
                  className='engagement__icon v1-engagement__links--icon'
                  src={link.img}
                  alt={link.title}
                />
                <p className='v1-engagement__links--title mt-2'>{link.title}</p>
              </div>
            ))}
            <div
              className='v1-engagement__contact_us'
              onClick={() =>
                handleRedirect(brandEngagement?.page?.contactUs?.url || defaultUrl.CONTACT)
              }
            >
              <img
                className='engagement__icon v1-engagement__links--icon'
                src={brandEngagement?.page?.contactUs?.img ?? ContactUsImg}
                alt='contact us'
              />
              <p className='v1-engagement__links--title mt-2'>{brandEngagement?.page?.contactUs?.title ?? 'Contact us'}</p>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default Links
